module.exports = function(bitmap, value){
  return {
    enumerable  : !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable    : !(bitmap & 4),
    value       : value
  };
};


//////////////////
// WEBPACK FOOTER
// G:/proyectos/website - IntergraMAI/webMai/~/core-js/modules/_property-desc.js
// module id = ../../../../core-js/modules/_property-desc.js
// module chunks = 0